export default "__VITE_ASSET__Cr2HKI0d__"